<template>
  <v-card outlined class="mb-2">
    <v-card-text class="pa-3">
      <div class="d-flex justify-space-between align-center mb-1">
        <router-link
          :to="getAccountRoute({ name: 'pipeline', params: { id: item._key }})"
          class="text-decoration-none"
        >
          <strong class="primary--text text-body-1">{{ item.deal_name || item.name }}</strong>
        </router-link>
      </div>

      <v-list dense class="pa-0">
        <v-list-item v-if="item.stage" class="px-0 py-1" style="min-height: 28px;">
          <v-list-item-icon class="mr-2 my-0">
            <v-icon small>mdi-chart-timeline-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="text-body-2">{{ item.stage }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="item.size" class="px-0 py-1" style="min-height: 28px;">
          <v-list-item-icon class="mr-2 my-0">
            <v-icon small>mdi-ruler-square</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="text-body-2">{{ formattedSize }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="item.consideration" class="px-0 py-1" style="min-height: 28px;">
          <v-list-item-icon class="mr-2 my-0">
            <v-icon small>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="text-body-2">{{ formattedConsideration }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="item.days_open" class="px-0 py-1" style="min-height: 28px;">
          <v-list-item-icon class="mr-2 my-0">
            <v-icon small>mdi-calendar-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="text-body-2">{{ daysOpenText }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { IAiPipelineResult } from '@/bundles/AiAgent/types';
import { formatNumber, formatCurrency } from '@/utils/filters';

export default mixins(AccountLayoutMixin).extend({
  name: 'PipelineCard',

  props: {
    item: {
      type: Object as PropType<IAiPipelineResult>,
      required: true,
    },
  },

  computed: {
    formattedSize (): string {
      if (!this.item.size) return 'N/A';
      return `${formatNumber(this.item.size)} SF`;
    },

    formattedConsideration (): string {
      if (!this.item.consideration) return 'N/A';
      return formatCurrency(this.item.consideration);
    },

    daysOpenText (): string {
      const days = this.item.days_open;
      if (!days) return 'N/A';
      return days === 1 ? '1 day open' : `${days} days open`;
    },
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__icon {
  align-self: center !important;
}
</style>
